import React, { useState } from 'react';

const SearchableSelect = ({ options, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setSearchTerm('');
    setDropdownOpen(false);
    onSelect(option);
  };

  return (
    <div className="searchable-select">
      <div className="select-header" onClick={() => setDropdownOpen(!isDropdownOpen)}>
        {selectedOption ? selectedOption.label : 'Select an option'}
      </div>
      {isDropdownOpen && (
        <div className="dropdown">
          {/* <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          /> */}
          <ul>
            {filteredOptions.length ? (
              filteredOptions.map(option => (
                <li key={option.value} onClick={() => handleOptionClick(option)}>
                  {option.label}
                </li>
              ))
            ) : (
              <li>No options found</li>
            )}
          </ul>
        </div>
      )}
     
    </div>
  );
};

export default SearchableSelect;
